import React, { Component } from 'react';
import {Link} from 'react-router-dom';
class AboutUs extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}




  render() {
    return (
        <div className="container-xxl py-5 inner_con_grey home_about_us">
            <div className="container inner_con">
              <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">About US</h1>
                <div className="row g-4">
                    <div className="col-lg-6 wow fadeIn about-img-div-margin-top" data-wow-delay="0.1s">
                        <div className="row g-0 about-bg rounded overflow-hidden">
                            <div className="col-12 text-start">
                                <img className="img-fluid w-100" src="/assets/img/about_main11.png"/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 wow fadeIn about-info-div-home" data-wow-delay="0.5s">
                <h3 className=''>We Help To Get The tailored Services with in legal periphery</h3>
                <p className="mb-4" style={{lineHeight:'25px'}}><b>BYLAWS Legal LLP (BYLAWS)</b> is a multi-disciplinary law firm providing legal, regulatory,
                transactional and dispute-resolution services across a broad spectrum of industries and practice
                areas. The firm is structured to support clients through complex legal and regulatory environments
                with clarity, discipline and professional integrity.</p>
                <p className="mb-4" style={{lineHeight:'25px'}}>Our practice is founded on a principled approach to law, combining rigorous legal analysis with
                practical understanding of business, regulation and institutional processes. We advise corporates,
                financial institutions, regulated entities and professionals across both contentious and non-
                contentious matters.</p>
                <p className="mb-2" style={{lineHeight:'25px'}}>BYLAWS operates with a clear focus on regulatory alignment, governance discipline and risk-
                aware legal strategy. Whether advising on compliance frameworks, corporate structuring,
                transactional execution or litigation, the firm places strong emphasis on precision, accountability
                and ethical conduct.</p>

                        <div className="text-align-right">
                            <Link to="/aboutus" className="btn btn-primary py-3 px-5 mt-3 home_ab_btn">Know More</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default AboutUs;
